/**
 * đang xem thông tin đơn vị ở mode nào
 */
export default {
    TopNav: 1,
    OrganizationUnder: 2
  };